






import { Component, Prop, Watch } from 'vue-property-decorator';
import DictMixin from '@/mixins/dict-mixin';
import { mixins } from 'vue-class-component';
@Component
export default class RoseChart extends mixins(DictMixin) {
  @Prop() indData!: any;

  option: any = {};

  @Watch('indData')
  onIndChange() {
    let data = this.indData.map((v: any) => ({
      name: v.title,
      value: v.value
    }));
    this.option = {
      series: [
        {
          type: 'pie',
          radius: '50%',
          roseSort: false,
          data,
          insideLabel: {
            show: false
          },
          outsideLabel: {
            formatter: '{name} {percent}%',
            labelLineEndLength: 20,
            style: {
              fill: '#fff'
            },
            labelLineStyle: {
              stroke: '#fff'
            }
          },
          roseType: true
        }
      ],
      color: ['#da2f00', '#fa3600', '#ff4411', '#ff724c', '#541200', '#801b00', '#a02200', '#5d1400', '#b72700']
    };
  }
}
